'use strict';

module.exports = {
  template: require('./template.html')
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/favorite/index.js
// module id = 162
// module chunks = 0